import React, { Fragment } from "react";

import CmsBlocks from "theme/libs/wordpress/content/CmsBlocks";
import Div from "theme/layouts/Div";
import Grid from "theme/layouts/Grid";
import PropTypes from "prop-types";
import TextLink from "theme/components/text/TextLink";
import TextStyles from "theme/components/text/TextStyles";
import Waterfall from "theme/layouts/Waterfall";
import transformHeading from "theme/libs/wordpress/utils/transformHeading";
import Column from "theme/layouts/Column";
import styled from "theme/libs/styled";
import useBelowBreakpoint from "core-web/hooks/useBelowBreakpoint";

const HeaderWrapper = styled(Column)`
    grid-column: 1 / -1;
    gap: 22px 8px;

    ${({ theme }) => theme.above.tabletLg} {
        flex-direction: row;
        justify-content: space-between;
        align-items: end;
    }
`;

const TwoColumnsLayout = ({ content }) => {
    const isMobile = useBelowBreakpoint("tabletLg");

    const { data, module_settings } = content || {};

    // We should not render the two column if the data is not correct.
    if (data?.columns?.length !== 2) {
        return null;
    }

    const numberOfColumns = data.columns?.length;

    // const reverseColumns = !!module_settings?.reverse_columns_in_mobile === "yes"; //TODO: implement reverseColumms
    const addModuleHeading = module_settings?.add_module_heading;
    const moduleHeader = transformHeading(data.heading.heading);

    const moduleLink = {
        text: data.heading?.link?.text || undefined,
        url: data.heading?.link?.url || undefined,
    };

    // Media query for layout templates that cover the whole column
    const mediaQuery = {
        w: [335, 535, 745, 495, 660, 745],
        q: 70,
    };

    return (
        <Waterfall as="section" my={["64px", null, null, null, "104px"]} rowGap="24px">
            {/* TODO: set margin as variable */}
            {addModuleHeading && (moduleHeader?.text || (moduleLink?.url && moduleLink.text)) && (
                <HeaderWrapper>
                    <>
                        {moduleHeader.text && (
                            <TextStyles
                                as={moduleHeader.type}
                                color={moduleHeader.color}
                                textStyles={moduleHeader.textStyle}
                                textWrap="balance"
                            >
                                {moduleHeader.text}
                            </TextStyles>
                        )}

                        {moduleLink.url && moduleLink.text && (
                            <TextLink
                                to={moduleLink.url}
                                withArrow={isMobile}
                                textStyles={["Myriad Pro/16-100", null, null, null, "Myriad Pro/18-100"]}
                                whiteSpace="nowrap"
                                color="#282828b3"
                            >
                                {moduleLink.text}
                            </TextLink>
                        )}
                    </>
                </HeaderWrapper>
            )}

            <Grid columns={[1, null, null, 2]}>
                {data.columns?.map((data, i) => (
                    <Fragment key={i}>
                        <Div as="article" key={`${data.layout}${i}`} aspectRatio={[null, null, null, 3 / 4]}>
                            <CmsBlocks isColumn data={data} numberOfColumns={numberOfColumns} mediaQuery={mediaQuery} />
                        </Div>
                    </Fragment>
                ))}
            </Grid>
        </Waterfall>
    );
};

TwoColumnsLayout.propTypes = {
    content: PropTypes.object,
    isFirstModule: PropTypes.bool,
};

TwoColumnsLayout.defaultProps = {
    content: undefined,
    isFirstModule: false,
};

export default TwoColumnsLayout;
